import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";


@Component({
  selector: 'app-manage-placeholder',
  templateUrl: './manage-placeholder.component.html',
  styleUrls: ['./manage-placeholder.component.scss']
})
export class ManagePlaceholderComponent implements OnInit {

savingInProgress: boolean=false;
    isUserCanEdit: any;
  isCancelling: any;
  isSaving: any;
  isFormDataValid: any;
  botForm: FormGroup;


  constructor(public dialogRef: MatDialogRef<ManagePlaceholderComponent>,
              private botFormBuilder: FormBuilder) {
    this.botForm = this.botFormBuilder.group({
      placeholderId: new FormControl( '', [Validators.required]),
      displayName: new FormControl('', [Validators.required]),
      description: new FormControl( '', [Validators.required]),
      dataType: new FormControl('', [Validators.required]),
      minLength: new FormControl('', ),
      maxLength: new FormControl('', ),
      regularExpression: new FormControl('', ),
      hint: new FormControl('', ),
      prepopulatedValue: new FormControl('', ),
    });
  }
  private labelGroup: FormBuilder


  ngOnInit(): void {
  }

  canSaveBot() {
    return true;
    }
    saveBot() {
    throw new Error('Method not implemented.');
    }

  cancel() {
    
  }

  saveAPI() {
    
  }

  saveFlow() {

  }

  canSaveFlow() {
    return false;
  }
  setHighLight() {
    return false;
  }
  closeModal() {
    this.dialogRef.close();
  }
}
